export const getLocalData = name => {
  const local = localStorage.getItem(name);
  const localData = !!local && JSON.parse(local);
  return localData || false;
};

export const appendLocalData = (name, data = {}) => {
  const prevData = getLocalData(name) || {};
  let currentData = prevData;
  const newData = data || {};
  if (!!data) {
    currentData = {
      ...prevData,
      ...newData,
    };
    setLocalData(name, currentData);
  }
  return currentData;
};

export const setLocalData = (name, data) => {
  localStorage.setItem(name, JSON.stringify(data));
  return data;
};

export const removeLocalData = name => {
  localStorage.removeItem(name);
};

export const getLocalWithExpiry = name => {
  const itemStr = getLocalData(name);

  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    removeLocalData(key);
    return null;
  }
  return item?.data;
};

export const setLocalWithExpiry = (name, data, ttl) => {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    data: data,
    expiry: now.getTime() + ttl,
  };
  setLocalData(name, item);
};

// local User
export const getLocalUser = () => {
  return getLocalData("schoolinked_user");
};
export const appendLocalUser = data => {
  return appendLocalData("schoolinked_user", data);
};
export const setLocalUser = data => {
  return setLocalData("schoolinked_user", data);
};
export const removeLocalUser = () => {
  return removeLocalData("schoolinked_user");
};

// local Active School
export const getLocalSchool = () => {
  return getLocalData("schoolinked_school");
};
export const getLocalSchools = () => {
  const localUser = getLocalUser();
  return localUser?.schools;
};
export const appendLocalSchool = data => {
  return appendLocalData("schoolinked_school", data);
};
export const setLocalSchool = data => {
  return setLocalData("schoolinked_school", data);
};
export const removeLocalSchool = () => {
  return removeLocalData("schoolinked_school");
};
export const setLocalActiveSchool = school => {
  if (!!school?._id) {
    const localUser = getLocalUser();
    const schoolData = {
      _id: school?._id,
      key: school?.key,
      name: school?.name,
      searchName: school?.searchName,
      subjects: school?.subjects,
      email: school?.email,
      image: school?.image || null,
      language: school?.language || localStorage.getItem('i18nextLng') || process.env.DEFAULT_LANGUAGE || "fr",
    };
    setLocalSchool(schoolData);
    setLocalUser({
      ...localUser,
      activeSchool: schoolData,
    });
  }
};

// local Child
export const getLocalChild = () => {
  return getLocalData("schoolinked_child");
};
export const appendLocalChild = data => {
  return appendLocalData("schoolinked_child", data);
};
export const setLocalChild = data => {
  return setLocalData("schoolinked_child", data);
};
export const removeLocalChild = () => {
  return removeLocalData("schoolinked_child");
};
export const setLocalActiveChild = child => {
  const localUser = getLocalUser();
  !!child?._id &&
    setLocalChild({
      _id: child?._id,
      description: child?.description,
      school: child?.school,
      language: child?.school?.language || localStorage.getItem('i18nextLng') || process.env.DEFAULT_LANGUAGE || "fr",
      image: child?.image || null,
      parent: localUser?._id,
    });
  !!child?.school?.key && setLocalActiveSchool(child?.school);
};

// local login function
export const setInitLocalUserAndSchool = userData => {
  const defaultEnvKey = `base-${
    process.env.BASE_ENV == "local" ? "development" : process.env.BASE_ENV
  }`;

  // set default school or choose first from array
  const defaultSchool =
    userData?.schools?.find(
      sch => sch?.key == userData?.school || sch?.key == defaultEnvKey,
    ) || userData?.schools?.[0];

  //console.log({ defaultSchool }, userData?.schools, userData?.school);

  setLocalUser({
    _id: userData?._id,
    school: userData?.school,
    activeSchool: defaultSchool,
    schools: userData?.schools,
    token: userData?.token,
    role: userData?.role,
    image: userData?.image,
    confirmed: userData?.confirmed,
    description: userData?.description,
    lastOpenedApp: userData?.lastOpenedApp,
  });

  setLocalSchool(defaultSchool);

  return {
    activeSchool: defaultSchool,
    schools: userData?.schools,
  };
};

export default {
  // root
  getLocalData,
  appendLocalData,
  setLocalData,
  removeLocalData,
  setLocalWithExpiry,
  getLocalWithExpiry,
  setInitLocalUserAndSchool,

  // local User
  getLocalUser,
  appendLocalUser,
  setLocalUser,
  removeLocalUser,

  // local Active School
  getLocalSchool,
  appendLocalSchool,
  setLocalSchool,
  removeLocalSchool,
  // schools
  getLocalSchools,
  setLocalActiveSchool,

  // local Child
  getLocalChild,
  appendLocalChild,
  setLocalChild,
  removeLocalChild,
  setLocalActiveChild,
};
